import { render, staticRenderFns } from "./IndexPontoFiqColaboradores.vue?vue&type=template&id=be639a42&scoped=true"
import script from "./IndexPontoFiqColaboradores.vue?vue&type=script&lang=js"
export * from "./IndexPontoFiqColaboradores.vue?vue&type=script&lang=js"
import style0 from "./IndexPontoFiqColaboradores.vue?vue&type=style&index=0&id=be639a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be639a42",
  null
  
)

export default component.exports